// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PreviewProjectContainer_wrap__2AWQI","title":"PreviewProjectContainer_title__1DCgX"};